import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { map, skip } from 'rxjs/operators';

import { TopnavInfoService } from '../menuInterfaces/topnav-info.service';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarComponent {
    logoFile$ = this.navService.getLogoFilename();
    userDisplayName$ = this.navService.getUserName();
    modules$ = this.navService.getModules();
    currentModuleDescription$ = this.navService.getModuleName(this.route);
    currentModulePath$ = this.navService.getModulePath(this.route);
    userRole$ = this.navService.getUserRoles();

    d$ = this.route.data;

    constructor(
        private navService: TopnavInfoService,
        private route: ActivatedRoute
    ) {}

    rolesOk = (roles: string[]) => {
        if (!roles) {
            return of(true);
        }

        return this.userRole$.pipe(
            map(userRoles => roles.some(role => userRoles.indexOf(role) >= 0))
        );
    };
}
